import { useState } from 'react';
import { createRoot } from 'react-dom/client';

import { BrowserRouter, Route, Routes, Link } from "react-router-dom"

import Box from '@mui/material/Box'

import Header from "./Header";

import News from './Section4/News';

import Footer3 from './Footer3';

export default function Part4() {

  return (

    <>

        <News />

        <Footer3 />

    </>

  );
}

